/**
 * =============================================================================
 * cart.js
 * =============================================================================
 * Collection of useful utilities for performing actions on the cart / minicart
 * =============================================================================
 */

var Cart = {
  selectors: {
    line_items_container: "[data-mp-cart-items]",

    line_item: "[data-mp-tile-line-item]",
    line_item_key: "data-mp-tile-line-item",
    line_item_quantity: "[data-mp-cart-item-quantity]",
    line_item_remove: "[data-mp-cart-item-remove]",

    cart_item_count: "[data-cart-item-count]", // Item count badges
    cart_item_count_attribute: "data-cart-item-count",
    cart_total_price: "[data-mp-total-price]", // Total price elements
    cart_total_discount: "[data-mp-total-discount]", // Total discount elemenets

    minicart: "cart-offcanvas",

    variant_quick_add: "[data-quick-add]"
  },

  minicart: null,

  /**
   * Document ready - TODO: replace this with vanilla JS onready
   */
  onReady: function(){
    $('body').on("change", this.selectors.line_item_quantity, this.onLineItemQuantityChange.bind(this));
    $('body').on("click", this.selectors.line_item_remove, this.onLineItemRemove.bind(this));

    $('body').on("click", this.selectors.variant_quick_add, this.onVariantQuickAdd.bind(this));

    this.minicart = new bootstrap.Offcanvas(document.getElementById(this.selectors.minicart));
  },

  /**
   * Add a variant using the data-quick-add attribute as the variant ID
   * 
   * @param {Event} e 
   */
  onVariantQuickAdd: function(e) {
    let quickAddElement = e.target.closest(this.selectors.variant_quick_add);
    let spinner = quickAddElement.querySelector(".spinner-overlay");
    let item = { id: quickAddElement.dataset.quickAdd, quantity: 1 };
    if(spinner) {
      quickAddElement.querySelectorAll("span").forEach(e => {
        e.classList.add("opacity-0")
      });
      spinner.classList.remove("d-none");
    }

    let variantId = quickAddElement.dataset.quickAdd;
    let properties = {};
    if(quickAddElement.dataset.quickAddProperties){
      let propertiesArray = JSON.parse(atob(quickAddElement.dataset.quickAddProperties));
      propertiesArray.forEach(e => {
        let propertyParts = e.split("||||");
        properties[propertyParts[0]] = propertyParts[1];
      });
    } 
    item.properties = properties;

    let sellingPlanId = quickAddElement.dataset?.quickAddSellingPlan || null;
    if(sellingPlanId){
      item.selling_plan = sellingPlanId;
    }

    this.add(item).finally(() => {
      if(spinner) {
        quickAddElement.querySelectorAll("span").forEach(e => {
          e.classList.remove("opacity-0");
        });
        spinner.classList.add("d-none");
      }
    });
  },

  /**
   * Remove a line item from the cart
   * 
   * @param {Event} e 
   */
  onLineItemRemove: function(e) {
    e.preventDefault();
    var lineItem = $(e.currentTarget).closest(this.selectors.line_item);
    var lineItemKey = lineItem.attr(this.selectors.line_item_key);
    var payload = { id: lineItemKey, quantity: 0 };
    this.change(payload);
  },

  /**
   * Update quantity of a line item in the cart
   * 
   * @param {Event} e 
   */
  onLineItemQuantityChange: function(e) {
    var lineItem = $(e.target).closest(this.selectors.line_item);
    var lineItemKey = lineItem.attr(this.selectors.line_item_key);
    var payload = { id: lineItemKey, quantity: $(e.target).val() };
    this.change(payload);
  },

  /**
   * Fetch the minicart HTML and update
   */
  fetchAndRenderMinicart: function(show = true) {
    // Get the template-namespaced ID of the cart-items section to dynamically render
    const sectionId = document.querySelector(".cart-offcanvas").id.replace("shopify-section-", "");
    const fetchPromise = fetch(`${location.pathname}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(response => {
        document.querySelector('.cart-offcanvas').innerHTML = response;
        const parsedHtml = new DOMParser().parseFromString(response, 'text/html');
        const numItems = parseInt(parsedHtml.querySelector("#cart-offcanvas-content").dataset.cartItemsCount);
        let itemCounts = document.querySelectorAll("[data-cart-item-count]");
        itemCounts.forEach(e => {
          e.dataset.cartItemCount = numItems;
          e.innerHTML = numItems; 
        });
        mp_lazyload_setup();
        if(show){
          this.minicart.show();
        }
      })
      .finally(() => $('.cart-loading').addClass('d-none'));
  },

  fetchAndRenderCart: function() {
    // Get the template-namespaced ID of the cart-items section to dynamically render
    const sectionId = document.querySelector(".cart").id.replace("shopify-section-", "");
    const fetchPromise = fetch(`${location.pathname}?section_id=${sectionId}`)
      .then(response => response.text())
      .then(response => {
        const parsedHtml = new DOMParser().parseFromString(response, 'text/html');
        const numItems = parseInt(parsedHtml.querySelector("#cart-container").dataset.cartItemsCount);
        let itemCounts = document.querySelectorAll("[data-cart-item-count]");
        itemCounts.forEach(e => {
          e.dataset.cartItemCount = numItems;
          e.innerHTML = numItems; 
        });
        if(numItems > 0){
          const lineItemsGrid = parsedHtml.getElementById("line-items-grid");
          document.querySelector('#line-items-grid').innerHTML = lineItemsGrid.innerHTML;
  
          const cartTotals = parsedHtml.getElementById("cart-totals");
          document.querySelector('#cart-totals').innerHTML = cartTotals.innerHTML;

          const cartShippingContent = parsedHtml.getElementById("cart-shipping-content");
          if(cartShippingContent){
            document.querySelector('#cart-shipping-content').innerHTML = cartShippingContent.innerHTML;
          }
  
          mp_lazyload_setup();
  
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
        } else {
          document.querySelector("#cart-container").outerHTML = parsedHtml.querySelector("#cart-container").outerHTML;
        }
      })
      .finally(() => $('.cart-loading').addClass('d-none'));
  },

  /**
   * Update items already in the cart
   * 
   * @param {Object} updates 
   * @returns {Promise}
   */
  change: function(updates) {
    $('.cart-loading').removeClass('d-none');

    // Setup the fetch config
    const config = MP.Utilities.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(updates);

    // Parse the response to JSON for any other callbacks
    const fetchPromise = fetch(`${routes.cart_change_url}`, config).then(response => response.json());

    // Handle the promise
    fetchPromise
      .then(response => this.handleCartUpdated(response, window.cartStrings.updated))
      .catch(error => {
        this.handleErrorMessage(error.message);
        $('.cart-loading').addClass('d-none');
      });

    // Pass the promise back to the caller to do any caller-specific handling
    return fetchPromise;
  },

  /**
   * Add item(s) to the cart
   * 
   * @param {Object} data 
   * @returns {Promise}
   */
  add: function(data) {
    $('.cart-loading').removeClass('d-none');

    // Setup the fetch request
    const config = MP.Utilities.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    // Determine the payload
    if(data instanceof FormData){ // Product form is passed as a FormData object, *not* JSON
      config.body = data;
      delete config.headers['Content-Type'];
    } else if (data instanceof Array){ // Simple array of variant objects - i.e [{id: XXX, quantity: 1, properties: {}}]
      config.body = JSON.stringify({ items: data })
    } else { // Single variant object, so we wrap in an array
      config.body = JSON.stringify({ items: [data] })
    }

    // Parse the response to JSON for any other callbacks
    const fetchPromise = fetch(`${routes.cart_add_url}`, config).then(response => response.json());

    // Handle the promise
    fetchPromise
      .then(response => this.handleCartUpdated(response, window.cartStrings.added))
      .catch(error => {
        this.handleErrorMessage(error.message);
        $('.cart-loading').addClass('d-none');
      });

    // Pass the promise back to the caller to do any caller-specific handling
    return fetchPromise;
  },

  /**
   * Handle a cart add response
   * 
   * @param {Object} response The JSON response
   * @returns {Promise} The Promise from renderCarts()
   */
  handleCartUpdated: function(response, successMessage) {
    if (response.status) {
      this.handleErrorMessage(response.description);
      $('.cart-loading').addClass('d-none');
      return;
    }

    //MP.Utilities.toast("success", successMessage, "fad fa-check-circle");
    return this.renderCarts();
  },

  /**
   * Display error on failure
   */
  handleErrorMessage: function(errorMessage) {
    MP.Utilities.toast("warning", errorMessage, "fal fa-exclamation-triangle");
  },

  /**
   * Render the current cart / minicart
   * 
   * @returns {Promise}
   */
  renderCarts: function() {
    let openMinicart = true;
    if(window.disableNextMinicartOpen){
      openMinicart = false;
      delete window.disableNextMinicartOpen;
    }
    
    // Actually get the cart 
    if(MP.Utilities.isCartPage()){
      this.fetchAndRenderCart();
      this.fetchAndRenderMinicart(false);
    } else {
      this.fetchAndRenderMinicart(openMinicart);
    }
    
    const fetchPromise = fetch(`${routes.cart_url}.js`).then(response => response.json());
    fetchPromise.then(response => {
      let event = new CustomEvent("cart:updated", {
        detail: {
          response: response,
          cart: response.items,
          total_price: response.total_price,
          total_discount: response.total_discount
        }
      });
      document.dispatchEvent(event);
    });

    return fetchPromise;
  }
}

export default Cart;